.container {
  width: 100%;
  max-width: 48rem;
  margin: 0 auto;
}

.summaryHeader {
  /* border-top: 1px solid var(--static-divider-standard); */
  /* border-bottom: 1px solid var(--static-divider-standard); */
  /* padding: 0.75rem 1rem; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.summaryButton {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  /* padding: 0.5rem 1rem; */
  font-family: inherit;
}

.summaryTitle {
  font-size: var(--fs-normal);
  color: var(--static-text-strong);
  font-weight: 500;
}

.chevron {
  width: 1.25rem;
  height: 1.25rem;
  transition: transform 0.2s ease;
}

.rotated {
  transform: rotate(180deg);
}

.tableContainer {
  margin-top: 16px;
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.375rem;
}

.tableRow {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom: 1px solid var(--static-divider-standard);
}

.tableHeaderCell {
  padding: 1rem;
  text-align: center;
  font-weight: 500;
  color: var(--static-text-strong);
}

.tableCell {
  padding: 1rem;
  text-align: center;
}

.tableLabelCell {
  padding: 1rem;
  font-weight: 500;
  color: var(--static-text-strong);
}

.badgeContainer {
  position: relative;
}

.badge {
  position: absolute;
  left: -2rem;
  background-color: var(--primary-enabled);
  color: white;
  border-radius: 0.25rem;
  padding: 0 0.25rem;
  font-size: var(--fs-x-small);
}

.positiveValue {
  color: var(--sentiment-text-positive);
}

.negativeValue {
  color: var(--sentiment-text-negative);
}